import React from 'react';
import { motion } from 'framer-motion';
import {
  Box,
  HStack,
  Text,
  Button,
  Flex
} from '@chakra-ui/react';

const BudgetHeader = ({ budget, style = 'women', onEdit, isVisible = false }) => {
  if (!isVisible || !budget) return null;

  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <Box 
        className="bg-gradient-to-r from-orange-50 to-orange-100 border-b border-orange-200 px-6 md:px-8 py-4"
      >
        <Flex justify="space-between" align="center">
          <HStack spacing={4}>
            <HStack spacing={2}>
              <Text fontSize="lg" className="text-stone-700">
                💰
              </Text>
              <Text 
                fontWeight="600" 
                fontSize="md"
                className="text-stone-800"
              >
                Budget: 
                <Text 
                  as="span" 
                  className="text-blue-600 ml-1"
                  fontWeight="700"
                >
                  ${budget.toLocaleString()}
                </Text>
              </Text>
            </HStack>
            
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2, duration: 0.3 }}
              className="flex items-center gap-2 px-3 py-1 bg-gradient-to-r from-rose-100 to-rose-50 rounded-lg border border-rose-400/10"
            >
              <Text fontSize="sm">👤</Text>
              <Text 
                fontSize="sm" 
                fontWeight="500"
                className="text-rose-500"
              >
                {style === 'women' ? "Women's" : "Men's"}
              </Text>
            </motion.div>
          </HStack>

          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              onClick={onEdit}
              variant="ghost"
              size="sm"
              className="text-rose-500 hover:bg-rose-50 hover:text-rose-600 
                       transition-all duration-200 font-medium"
              leftIcon={
                <span className="text-sm">✏️</span>
              }
            >
              Edit
            </Button>
          </motion.div>
        </Flex>
      </Box>
    </motion.div>
  );
};

export default BudgetHeader;